import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PwaService } from './shared/services/pwa.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { DialogInstallPromptDialog } from './shared/dialogs/install-prompt-dialog/install-prompt-dialog.component';
import { DialogInstallPromptIOSDialog } from './shared/dialogs/install-prompt-dialog-ios/install-prompt-dialog-ios.component';
import { DialogBrowserInfoDialog } from './shared/dialogs/browser-info-dialog/browser-info-dialog.component';

import { FunctionCallService } from './shared/services/function-calls.service';
import { AppNavigationService } from './shared/services/app-navigation.service';


/// <reference types="google.analytics" />
// import {} from '@types/google.analytics'; 
declare let ga: any;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit
{
  
  title = 'ACL SCOREBOARD';

  version = environment.version;


  isInstallPromptOpen = false;
  installPromptDialog: MatDialogRef<DialogInstallPromptDialog>;
  installPromptIOSDialog: MatDialogRef<DialogInstallPromptIOSDialog>;
  browserInfoDialog: MatDialogRef<DialogBrowserInfoDialog>;
  displayMode: string;

  // showIOSOnlyInstallButton = false;


  constructor(private router: Router,
              public pwaService: PwaService,
              public googleAnalyticsService: GoogleAnalyticsService,
              private functionCallService: FunctionCallService,
              private appNavigationService: AppNavigationService,
              public dialog: MatDialog)
              {
                this.router.events.subscribe((event) => 
                {
                  if (event instanceof NavigationEnd) 
                  {
                    ga('set', 'page', event.urlAfterRedirects);
                    ga('send', 'pageview');
                  }
                });

                this.appNavigationService.showBackButton();
              }


  ngOnInit()
  {

    // This was used in the basic example
    // See below that check for iOS and non iOS
    // window.addEventListener('beforeinstallprompt', (event) =>
    // {
    //   // console.log('beforeinstallprompt ngOnIt');

    //   // Prevent the mini-infobar from appearing on mobile
    //   event.preventDefault();      

    //   // Stash the event so it can be triggered later.
    //   this.promptEvent = event;

    //   // Update UI notify the user they can install the PWA
    //   // showPWAInstallPromotion();      

    // });

    this.functionCallService.addToHomeScreenEvents$.forEach((event) => 
    {
      this.openInstallPromptDialog();
      console.log(event);
      return; 
    });


    this.functionCallService.addToHomeScreenIOSEvents$.forEach((event) => 
    {
      if(event == 'addToHomeScreen')
      {
        this.openInstallPromptIOSDialog();
      }
      
      console.log('this.functionCallService.addToHomeScreenIOSEvents$', event);
      return; 
    });


    this.functionCallService.checkForUpdateEvents$.forEach((event) => 
    {
      this.checkForUpdate();
      console.log(event);
      return; 
    });


    this.functionCallService.getBrowserInfoEvents$.forEach((event) => 
    {
      this.pwaService.getBrowserInfo();
      console.log(event);

      // Open Browser Dialog
      this.openBrowserInfoDialog();
      return; 
    });



    // ----------------------------------------------
    // Check the Device Info for Install Prompt
    // ----------------------------------------------
    this.pwaService.checkDeviceInfo();



    // ----------------------------------------------
    // Detect when the PWA was successfully installed 
    // ----------------------------------------------
    window.addEventListener('appinstalled', (event) => 
    {
      // Log install to analytics
      console.log('INSTALL: Success');

      this.functionCallService.storedDefferedPrompt(null); 

      // Send event to Google Analytics It was installed
      this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'pwaInstalledSuccessfully', `appInstalled`, 1);       
    });   



    // ----------------------------------------------
    // Track how the PWA was launched
    // ----------------------------------------------
    window.addEventListener('DOMContentLoaded', () => 
    {
      this.displayMode = 'browser tab';

      if ((navigator as any).standalone) 
      {
        this.displayMode = 'standalone-ios';
      }

      if (window.matchMedia('(display-mode: standalone)').matches) 
      {
        this.displayMode = 'standalone';

      } 
      else
      {
        // this.checkDeviceInfo();        
      }   
      
      // Log launch display mode to analytics
      console.log('DISPLAY_MODE_LAUNCH: ', this.displayMode);
      // Send event to Google Analytics
      this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'pwaLaunchMode', `${ this.displayMode }`, 1);



      // ----------------------------------------------
      // Track when the display mode changes
      // ----------------------------------------------
      window.matchMedia('(display-mode: standalone)').addListener((event) => 
      {
        this.displayMode = 'browser tab';
        if (event.matches)
        {
          this.displayMode = 'standalone';
        }
        // Log display mode change to analytics
        console.log('DISPLAY_MODE_CHANGED', this.displayMode);

        // Send event to Google Analytics
        this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'displayModeChanged', `${ this.displayMode }`, 1);        
      });  

    });       




    // ----------------------------------------------
    // Check for iOS device
    // ----------------------------------------------
    // if(this.browserObj.os == 'iOS')
    // {
    //   // Add Dialog Here to show how to Add to Home Screen
    //   // this.openInstallPromptIOSDialog();

    //   // Show Install to Home Screen Button for IOS / Safari Only
    //   this.showIOSOnlyInstallButton = true; 
    //   // iOS analytics
    //   // Send event to Google Analytics It was installed
    //   this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'iosDevice', `deviceType`, 1);      

    // }

    // if((navigator as any).standalone == false) 
    // {
    //   // This is an iOS device and we are in the browser
    //   console.log('You can add this PWA to the Home Screen');

    //   alert('You can add this PWA to the Home Screen');

    //   // Add Dialog Here to show how to Add to Home Screen
    //   this.openInstallPromptIOSDialog();


    //   // iOS analytics
    //   // Send event to Google Analytics It was installed
    //   this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'iosDevice', `deviceType`, 1);         

    // }


    // if((navigator as any).standalone == undefined) 
    // {
    //   // ----------------------------------------------
    //   // It's NOT iOS
    //   // BROWSER could be Chrome, Firefox, or Safari
    //   // ----------------------------------------------
    //   if (window.matchMedia('(display-mode: browser').matches)
    //   {
    //     console.log('NON - IOS Device ---- ');

    //     // We are in the browser
    //     window.addEventListener('beforeinstallprompt', (event) =>
    //     {
    //       // Prevent the mini-infobar from appearing on mobile
    //       event.preventDefault();  

    //       // Stash the event so it can be triggered later.
    //       this.deferredPrompt = event;          

    //       // Update UI notify the user they can install the PWA
    //       // Use custom diglog prompt
    //       // This will Automatically show the Custom Install Prompt to the user
    //       // console.log('Install Prompt Opened automatically --');
    //       // Do NOT open the prompt automatically - 10-19-2020
    //       // this.openInstallPromptDialog();
    //       // window.removeEventListener('beforeinstallprompt', window);

    //       return false;
    //     });
    //   }
    //   else
    //   {
    //     if(this.browserObj.os == 'macOS' && this.browserObj.name == 'Safari')
    //     {
    //       console.log('Sarfari on MacOS : ', (navigator as any).standalone );

    //       this.showIOSOnlyInstallButton = true; 

    //       // Show Prompt - testing with Safari on MacOs
    //       // this.openInstallPromptIOSDialog();
    //     }

    //   }
    // }


    

  }




  // ----------------------------------------------
  // Button Can Trigger PWA Install if needed
  // ----------------------------------------------
  // Currently NOT Used Anywhere
  // onInstallPwa(): void 
  // {
  //   // Update UI notify the user they can install the PWA
  //   this.showPWAInstallPromotion(); 
  // }


  // ----------------------------------------------
  // Button Can Check for PWA Updates in the service
  // ----------------------------------------------
  checkForUpdate()
  {
    // Check to to see if the install prompt is open before prompt to update
    this.pwaService.checkForUpdate();
    
  }




  // --------------------------------------------------------
  // Open Install Prompt Match Dialog
  // --------------------------------------------------------
  openInstallPromptDialog() 
  {

    // Add flag to check to see if the dialog is currently open and not to show the update dialog at the same time
    this.isInstallPromptOpen = true;

    // console.log('sdjflskjfslj');
    this.installPromptDialog = this.dialog.open(DialogInstallPromptDialog, {
      disableClose: true,
      data: {
        type: 'type',
        
      },
      backdropClass: 'backdropBackgroundLight',
      panelClass: 'android-add-home-screen-dialog'       
    });

    this.installPromptDialog.afterClosed().subscribe(result => 
    {
      console.log('Result of OpenInstallPromptDialog: ', result);
      if(result)
      {
        // Install PWA
        // alert('Okay Clicked');
        // Update UI notify the user they can install the PWA
        this.pwaService.showPWAInstallPromotion();         
      }
      else
      {
        // Send event to Google Analytics It was NOT installed
        this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'closedInstallPrompt', `userChoice`, 1);  

      }
    });    
 
  }   



  // --------------------------------------------------------
  // Open Install Prompt Match Dialog for IOS devices
  // show screenshots of how to Add to homescreen
  // --------------------------------------------------------
  openInstallPromptIOSDialog() 
  {
    // console.log('sdjflskjfslj');
    this.installPromptIOSDialog = this.dialog.open(DialogInstallPromptIOSDialog, {
      disableClose: true,
      data: {
        type: 'type',
        
      },
      backdropClass: 'backdropBackgroundLight',
      panelClass: 'ios-add-home-screen-dialog'      
    });

    this.installPromptIOSDialog.afterClosed().subscribe(result => 
    {
      console.log('Result of OpenIOSDialog : ', result);
      if(result)
      {
        // Show how to Add to homescreen
        // Send event to Google Analytics It was NOT installed
        this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'openedInstallPromptIOS', `userChoice`, 1);          
      }
      else
      {
        // Send event to Google Analytics It was NOT installed
        this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'closedInstallPromptIOS', `userChoice`, 1);  

      }
    });    
 
  }     


  // --------------------------------------------------------
  // Open Browser Info Dialog to get browser info if needed
  // --------------------------------------------------------
  openBrowserInfoDialog() 
  {
    // Send event to Google Analytics It was NOT installed
    this.googleAnalyticsService.sendGoogleEvent('browserInfo', 'openedBrowserInfo', `userChoice`, 1);  

    // console.log('sdjflskjfslj');
    this.browserInfoDialog = this.dialog.open(DialogBrowserInfoDialog, {
      minWidth: '80%',
      disableClose: true,
      data: {
        data: this.pwaService.browserObj 
      },
      backdropClass: 'backdropBackgroundLight'      
    });

    this.browserInfoDialog.afterClosed().subscribe(result => 
    {
      console.log('Result of BrowserInfoDialog : ', result);
    });    
 
  } 

}



